import * as React from "react";
import {Link, useNavigate, useParams} from "react-router";
import {Categories} from "../../data/numericorder/numericorder";
import useSqids from "../../hooks/useSqids";
import Calendar from "react-calendar";

import 'react-calendar/dist/Calendar.css';

export default function NumericorderDatepicker() {

    const normalizeDate = (date) => {
        return new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate()
        );
    }

    const sqids = useSqids();

    const params = useParams();

    const navigate = useNavigate();

    const [selectedDate, setSelectedDate] = React.useState(normalizeDate(new Date()));

    const category = React.useMemo(() => {

        const [id] = sqids.decode(params.category);

        return Categories[id];

    }, [params, sqids]);

    /**
     * @param date {Date}
     * @returns {number}
     */
    const daysSince1980 = (date) => {
        return Math.floor(Number(date) / (24 * 60 * 60 * 1000)) + 1;
    }

    const numberOfDays = React.useMemo(() => {
        const f = daysSince1980(normalizeDate(selectedDate));
        return f;
    }, [selectedDate]);

    const play = () => {
        navigate(`/numericorder/${params.category}/${numberOfDays}`);
    }

    return <div style={{maxWidth: "500px"}}>
        <h1 className="text-center display-1 mb-2 mb-md-4">
            <Link className="text-dark" to={"/"}>Daily Puzzles</Link>
        </h1>

        <h2>
            <Link className="text-dark" to={"/numericorder"}>Numericorder</Link>
        </h2>

        <p className="lead">
            Guess the word based on it's numeric ranking in the list.
        </p>

        <h3 className="text-center">
            {category.name}&nbsp;
            <span
                className="badge rounded-pill text-bg-secondary">{category.entries.length}</span>
            <div className="small text-secondary">{category.description}</div>
        </h3>

        <div className="d-flex w-100 flex-column align-items-center justify-content-between gap-3">

            <Calendar onChange={(v) => setSelectedDate(v)} value={selectedDate} isOpen={true} maxDate={new Date()}/>

            <button onClick={play} className="btn btn-lg btn-outline-dark">
                Play
            </button>
        </div>

    </div>
}
